module.exports = __webpack_public_path__ + "media/images/athletes/3544-1b441eadfd6daa177f4488067e0630fd.png";